<template>
  <template v-for="portal in portals">
    <li class="stats-card">
      <a :href="portal.login" class="nav-link">
        <div
          class="nav-link-wrapper badge badge-secondary px-3 py-2"
          :class="{'bg-danger blink': portal.dialogues_count > 3, 'bg-danger': portal.dialogues_count === 3, 'bg-warning': portal.dialogues_count === 2,}"
        >
          {{ portal.name }}:
          <span class="mr-1" title="Dialogue count">{{ portal.dialogues_count ?? 0 }}</span>
          <i class="fas fa-comments"></i>
        </div>
      </a>
    </li>
  </template>
</template>

<script>
export default {
  name: 'DialogStatus',
  data() {
    return {
      portals: [],
    };
  },
  computed: {},
  methods: {
    fetchData: function () {
      axios.get('/ajax/portals/statuses')
        .then(response => {
          this.portals = response.data.data;
        })
        .catch(error => {

        });
    },
  },
  mounted() {
    this.fetchData();

    setInterval(() => {
      this.fetchData();
    }, 6 * 1000);
  }
};
</script>

<style lang="scss" scoped>
.nav-link-wrapper {
  font-size: 12px;

  &:hover {
    opacity: 0.85;
  }
}
</style>